// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__m3JMF","footerItems":"Footer_footerItems__MT5dr"};